<mat-expansion-panel class="flotante-panel" [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <mat-icon class="material-symbols-outlined">directions_bus</mat-icon>
      <span class="panel-title">Colectivos</span>
      <span class="counter-badge">{{ vehiculos ?? 0 }}</span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <!-- RECORRIDOS -->
  <div class="seccion">
    <div class="seccion-titulo">Recorridos</div>
    @if (recorridos && recorridos.length > 0) {
      <ng-select
        #select
        [items]="recorridos"
        placeholder="Recorridos"
        class="recorridos-select"
        multiple
        appendTo="body"
        bindLabel="nombre"
        [searchFn]="searchRecorridos"
        (change)="onRecorridoChange($event)"
        closeOnSelect="false"
        [clearSearchOnAdd]="false"
        (input)="onInput($any($event.target).value)"
        (open)="onOpen(select)"
      >
        <!-- (open)="$any(select).filterValue = searchTerm" -->
        <ng-template ng-option-tmp let-item="item">
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              gap: 0.5em;
            "
          >
            <p>
              <strong>{{ item.nombre }}</strong>
              @if (item.grupo?.nombre) {
                <span>
                  <strong>- Línea:</strong>
                  {{ item.grupo?.nombre }}
                </span>
              }
              @if (item.por) {
                <span>
                  <strong>Por:</strong>
                  {{ item.por }}
                </span>
              }
              @if (item.destino) {
                <span>
                  <strong>A:</strong>
                  {{ item.destino }}
                </span>
              }
            </p>
            <ngx-colors
              ngx-colors-trigger
              disabled
              [(ngModel)]="item.color"
            ></ngx-colors>
          </div>
        </ng-template>
      </ng-select>
    } @else {
      <span class="no-info">Sin recorridos</span>
    }
  </div>
</mat-expansion-panel>
